export default __webpack_public_path__ + "static/media/ic_frax_40.4728adab.svg";